import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const QuotedMessageXlFileIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M9.33317 1.33337H3.99984C3.2665 1.33337 2.67317 1.93337 2.67317 2.66671L2.6665 13.3334C2.6665 14.0667 3.25984 14.6667 3.99317 14.6667H11.9998C12.7332 14.6667 13.3332 14.0667 13.3332 13.3334V5.33337L9.33317 1.33337ZM11.9998 13.3334H3.99984V2.66671H8.6665V6.00004H11.9998V13.3334Z" />
    <rect
      x="4.99984"
      y="8.33333"
      width="2"
      height="0.666667"
      strokeWidth="0.666667"
    />
    <rect x="8.6665" y="8" width="2.66667" height="1.33333" />
    <rect x="4.6665" y="10.6666" width="2.66667" height="1.33333" />
    <rect x="8.6665" y="10.6666" width="2.66667" height="1.33333" />
  </Icon>
);

export default memo(QuotedMessageXlFileIcon);
